import service from '@/store/services/subcorridas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  subcorrida: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, subcorrida) => {
    state.subcorrida = subcorrida;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params, this.$axios)
      .then((subcorrida) => { commit('SET_RESOURCE', subcorrida); });
  },

  getDatosVenta({commit, dispatch}, params) {
    return service.getDatosVenta(params, this.$axios)
      .then((subcorrida) => { commit('SET_LIST', subcorrida); });
  },

  add({commit, dispatch}, params) {
    return service.add(params, this.$axios)
      .then((subcorrida) => { commit('SET_RESOURCE', subcorrida); });
  },

  update({commit, dispatch}, params) {
    return service.update(params, this.$axios)
      .then((subcorrida) => { commit('SET_RESOURCE', subcorrida); });
  },

  activate({commit, dispatch}, params) {
    return service.activate(params, this.$axios)
      .then((subcorrida) => { commit('SET_RESOURCE', subcorrida); });
  },

  deactivate({commit, dispatch}, params) {
    return service.deactivate(params, this.$axios)
      .then((subcorrida) => { commit('SET_RESOURCE', subcorrida); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  getDatosVenta: state => state.list,
  subcorrida: state => state.subcorrida,
  url: state => state.url
};

const subcorridas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default subcorridas;
